import "./CareCycle.module.css";
import Header from "@/reusable_sections/Header";
import TheCollaborativeProcess from "./sections/TheCollaborativeProcess";
import TheMethodology from "./sections/TheMethodology";
import JourneyMap from "./sections/JourneyMap";
import Footer from "@/reusable_sections/Footer";
export default function CareCyclePage() {
  return <div>
      <Header />
      <TheCollaborativeProcess />
      <TheMethodology />
      <JourneyMap />
      <Footer />
    </div>;
}